<template>
  <div>
    <div ref="StateDatePickerInput" class="state-date-picker-input">
      <p v-if="title" class="state-date-picker-input_title mb-8">
        {{ $t(title) }}<span v-if="required">*</span>
      </p>
      <label v-if="checkBox" class="checkbox-item mb-8">
        <input v-model="permanent" type="checkbox" />
        <i class="icon-check-box-outline-blank" />
        <i class="icon-check-box" />
        <p>{{ checkboxText }}</p>
      </label>
      <ValidationProvider v-slot="{ errors }" :rules="rules" class="input-wrap">
        <input type="hidden" :value="value" />
        <div
          v-click-outside="$_onCloseDatePicker"
          class="state-date-picker-input_input-item"
          :class="{ disabled: _disabled, error: errors.length > 0 }"
        >
          <div class="input-item" @click="$_datePickerOpen()">
            <i
              class="date-icon"
              :class="[leadingIcon, { disabled: _disabled, active: inputDate }]"
            />
            <input
              v-model="inputDate"
              type="text"
              :placeholder="placeholder ? $t(placeholder) : $t('YYYY-MM-DD')"
              class="date-input"
              :disabled="_disabled"
              @change="$_dateInputChange($event)"
            />
            <i
              v-if="!_disabled && inputDate"
              class="cancel-icon icon-cancel"
              @click.stop="$_onClickDelete()"
            />
          </div>
          <transition mode="out-in">
            <vc-date-picker
              v-if="datePickerActive"
              isInline
              :value="_value"
              :locale="_locale"
              :minDate="_minDate"
              :maxDate="_maxDate"
              :attributes="datePickerAttributes"
              class="date-picker"
              :class="{ 'drop-up': scroll !== undefined ? isDropUp : false }"
              @input="$_changeValue($event)"
            />
          </transition>
        </div>
        <div v-if="!noErrorText && errors.length > 0" class="invalid-text">
          <i class="icon-warning invalid-icon" />
          <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
            {{ $t(text_e) }}
          </p>
        </div>
      </ValidationProvider>
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import H_common from '@/helpers/common';

extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'StateDatePickerInput',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    notBeforeDisabledDate: {
      type: Boolean,
      default: false,
    },
    notAfterDisabledDate: {
      type: Boolean,
      default: false,
    },
    defaultDate: {
      type: Date,
      default: function () {},
    },
    afterDisabledDate: {
      type: Date,
      default: function () {},
    },
    disabledDate: {
      type: Date,
      default: function () {},
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    checkBox: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkboxText: {
      type: String,
      default() {
        return this.$t('永久效期');
      },
    },
    noValid: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    scroll: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: String,
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      today: new Date(),
      date: null,
      permanent: false,
      datePickerActive: false,
      inputDate: null,
      errorDate: false,
      C_errorText: null,
      C_error: null,
      datePickerAttributes: [
        {
          highlight: {
            class: 'calendar-background', // background
            contentClass: 'calendar-color', // color
          },
          dates: this.$moment().toDate(),
        },
      ],
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
      isDropUp: false,
    };
  },
  computed: {
    _value() {
      if (!this.value) {
        return this.defaultDate;
      } else {
        return new Date(this.value);
      }
    },
    _minDate() {
      if (!this.notBeforeDisabledDate) return null;
      if (this.disabledDate === 'Invalid Date' || !this.disabledDate) return null;
      return this.disabledDate;
    },
    _maxDate() {
      if (!this.notAfterDisabledDate) return null;
      if (this.afterDisabledDate == 'Invalid Date' || !this.afterDisabledDate) return null;
      return this.afterDisabledDate;
    },
    _locale() {
      const locale = this.$store.state.stone_locale.selectingLocale.code;
      return locale === 'tw'
        ? 'zh-TW'
        : locale === 'cn'
        ? 'zh-CN'
        : locale === 'ja'
        ? 'ja'
        : locale === 'us'
        ? 'en'
        : 'zh-TW';
    },
    _disabled() {
      return this.permanent || this.disabled;
    },
  },
  watch: {
    errorText() {
      this.C_errorText = this.errorText;
    },
    error() {
      this.C_error = this.error;
    },
    permanent() {
      if (this.permanent) {
        this.date = 'permanent';
        this.inputDate = '';
      } else {
        this.date = '';
        this.inputDate = '';
      }
      this.$emit('permanent-click', this.permanent);
    },
    value() {
      this.date = new Date(this.value);
      this.inputDate = this.value;
    },
    inputDate() {
      if (this.inputDate === 'permanent') {
        this.inputDate = '';
      }
      if (this.inputDate === 'Invalid date') {
        this.inputDate = '';
        this.$emit('input', this.inputDate);
      }
    },
    noValid() {
      if (this.noValid) {
        this.permanent = true;
      }
    },
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropUp();
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getDropdownHeight);
    window.addEventListener('resize', this.$_isDropUp);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getDropdownHeight);
    window.removeEventListener('resize', this.$_isDropUp);
  },
  mounted() {
    this.$_getDropdownHeight();
    this.$_isDropUp();
    this.inputDate = this.value;
    if (this.noValid) {
      this.permanent = true;
    }
  },
  methods: {
    $_changeValue(e) {
      let date;
      this.inputDate = this.$_dateFormat(e);
      if (this.permanent) {
        date = 'permanent';
      } else {
        // if (this.date === "") {
        //   date = this.date;
        // } else {
        date = this.$moment(e).format('YYYY-MM-DD');
        // }
      }
      this.$emit('input', date);
    },
    $_datePickerOpen() {
      if (this.permanent) return;
      this.datePickerActive = true;
    },
    $_onCloseDatePicker($event) {
      const { tagName: tarTag, type } = $event.target;
      if (tarTag === 'INPUT' && type === 'radio') return;
      this.datePickerActive = false;
    },
    $_dateInputChange($event) {
      let dateChange = $event.target.value;
      let date = this.$moment(dateChange).format('YYYY-MM-DD');
      if (date === 'Invalid date') {
        this.C_errorText = this.$t('錯誤格式');
        this.C_error = true;
        this.inputDate = '';
        this.$emit('input', this.inputDate);
        return;
      }
      if (this._maxDate && this.$moment(this._maxDate).isBefore(this.$moment(this.inputDate))) {
        this.inputDate = '';
        this.$emit('input', '');
        return;
      }
      if (this._minDate && this.$moment(this.inputDate).isBefore(this.$moment(this._minDate))) {
        this.inputDate = '';
        this.$emit('input', '');
        return;
      }
      this.date = new Date(date);
      this.$emit('input', date);
    },
    $_dateFormat(date) {
      return this.$moment(date).format('YYYY-MM-DD');
    },
    $_onClickDelete() {
      if (this._disabled) return;
      this.$emit('input', '');
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      const { height, y } = H_common.getComponentHeightAndY(this.$refs.StateDatePickerInput);
      this.dropdownHeight = height;
      this.dropdownTop = y;
    },
    $_isDropUp() {
      this.isDropUp = H_common.isDropUp(this.dropdownHeight, this.dropdownTop, 350, 350);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/state-date-picker-input';
</style>
